import {Feature} from "ol";
import {Point} from "ol/geom";
import {Fill, Stroke, Style, Text} from "ol/style";
import CircleStyle from "ol/style/Circle";
import {unByKey} from "ol/Observable";
import {ratingColorList} from "@/components/MapPage/MainMap/constant";
import {useMapStore} from "@/store/Map/map-store";
let resolutionChangeListener = null;

let currentFuture = null;

export const initializeMapHandlers = (map, openNewsList) => {
    // Открытие новостей при клике на точку
    const handleClick = (async (evt) => {


        let feature = map.forEachFeatureAtPixel(evt.pixel, function (feat) {
                return feat;
            }
        );

        if (feature && feature.get("type") === "news") {

            let vectorFlowerPoint;

            map.getLayers().forEach((layer) => {
                if (layer.getSource().get("name") === "flower") vectorFlowerPoint = layer.getSource();
            });

            // Закрытие цветка и списка новостей
            if (feature.get("isFlowerOpened") === true) {
                // Если клик на ту же самую новость, то
                // очищаем слой, закрываем список новостей и удаляем слушатель ресайза
                vectorFlowerPoint.clear();
                openNewsList({newsList: [], cityName: ""});
                removeListener();
                feature.set("isFlowerOpened", false);

                if (currentFuture === feature.get("newsList")[0]) return false;

                // Если клик на другую новость, только закрываем старую и дальше рендерим цветок на новой точке
            }

            currentFuture = feature.get("newsList")[0];
            feature.set("isFlowerOpened", true);

            // Открытие списка новостей справа
            // await openNewsList({newsList: feature.get('newsList'), cityName: feature.get('cityName')})
            const mapStore = useMapStore();
            const fullNewsList = await mapStore.getMapFullNews(feature.get("newsList"));
            openNewsList({newsList: fullNewsList, cityName: feature.get("cityName")});
            // Очищаем старые точки
            vectorFlowerPoint.clear();
            // Рендер цветка
            renderMultiPoint(map, feature, fullNewsList);


        }
    });
    map.on("click", handleClick);
};

export const removeListener = () => {
    if (resolutionChangeListener) {
        unByKey(resolutionChangeListener);
        resolutionChangeListener = null;
    }
};

//Рисуем ромашку на карте
const renderMultiPoint = (map, clickedFeature, fullNewsList) => {
    if (clickedFeature.values_.newsList.length < 3) return false;
    const geometry = clickedFeature.getGeometry();
    const coordinates = geometry.getCoordinates();

    const newsListLength = clickedFeature.values_.newsList?.length || 0;
    let quantityNews = newsListLength > 10 ? 10 : newsListLength;

    removeListener();

    // Вызов функции для первого рендера
    createFeatures(map, clickedFeature, coordinates, quantityNews, fullNewsList);
    // Подписка на события изменения разрешения карты
    resolutionChangeListener = map.getView().on("change:resolution", () => {
        createFeatures(map, clickedFeature, coordinates, quantityNews, fullNewsList);
    });

};

const createFeatures = (map, clickedFeature, coordinates, quantityNews, fullNewsList) => {
    let vectorFlowerPoint;

    map.getLayers().forEach((layer) => {
        if (layer.getSource().get("name") === "flower") vectorFlowerPoint = layer.getSource();
    });

    // Очищаем старые точки
    vectorFlowerPoint.clear();

    // Получаем текущий масштаб карты
    const view = map.getView();
    const zoom = view.getZoom();

    const newsListLength = () => {
        const length = clickedFeature.values_.newsList.length;

        if (length < 6) return 6;
        if (length >= 6 && length <= 10) return length;
        if (length > 10) return 10;
    };

    // Определяем динамический радиус на основе уровня масштабирования
    const baseRadius = 1000000 * newsListLength();

    const scaleFactor = Math.pow(2, zoom); // коэффициент масштаба
    const radius = baseRadius / scaleFactor; // динамический радиус

    const  calcCoordinates = (center, radius, quantityNews, index) => {
        const angle = (2 * Math.PI / quantityNews) * index; // Угол для текущей точки
        const newX = center[0] + radius * Math.cos(angle);
        const newY = center[1] + radius * Math.sin(angle);
        return [newX, newY];
    };

    let index = 0;
    for (let news of fullNewsList) {
        index += 1;
        if (index > 10) return false;

        const feature = new Feature({
            geometry: new Point(calcCoordinates(coordinates, radius, quantityNews, index)),
            geo_name: news.geo_name,
            importance: news.importance,
            title: news.title,
            id: news.id
        });

        let pointStyle;

        if (index !== 9) {
            pointStyle = new Style({
                image: new CircleStyle({
                    radius: 15, //было 10
                    fill: new Fill({ color: ratingColorList[news.importance] }), // Цвет заливки точки
                    stroke: new Stroke({ color: "white", width: 2 }) // Обводка точки
                }),
                stroke: new Stroke({ color: "black", width: 2 })
            });
        } else {
            pointStyle = new Style({
                image: new CircleStyle({
                    radius: 15, //было 10
                    fill: new Fill({ color: ratingColorList[news.importance] }), // Цвет заливки точки
                    stroke: new Stroke({ color: "white", width: 2 }) // Обводка точки
                }),
                text: new Text({
                    scale: 2,
                    offsetY: 2,
                    font: "14px Roboto,sans-serif",
                    overflow: true,
                    text: "+",
                    fill: new Fill({
                        color: "#ffffff"
                    }),
                }),
                stroke: new Stroke({ color: "black", width: 2 })
            });
        }

        feature.setStyle(pointStyle);

        vectorFlowerPoint.addFeature(feature);
    }

};